<template>
  <div class="pages">
    <img src="/static/other/banner_qy.png" class="tImg" />
    <div class="b_pic_text">
      {{ $t('main.companyNews') }}
    </div>
    <div class="content" id="scroll-box">
      <div class="dis">
        <div
          class="box"
          v-for="(item, index) in newsList"
          :key="index"
          @click="goToDetail(item)"
        >
          <img :src="item.thumb" class="oImg" />
          <div class="fother">
            <div class="intro">{{ item.release_time }}</div>
            <div class="btitle nowap">
              {{ item.title }}
            </div>
            <div class="bCont twowap">
              {{ item.description }}
            </div>
          </div>
        </div>
        <div class="no-data" v-if="!newsList.length">{{ $t('main.noData') }}</div>
      </div>
      <div>
        <el-pagination
          layout="prev, pager, next"
          hide-on-single-page
          :total="total"
          :current-page="page"
          :page-size="limit"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getContents
} from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      cat_id: 0,
      page: 1,
      limit: 6,
      total: 1000,
      categoryInfo: {},
      newsList: [],
      searchBarFixed: false
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        let tabs = this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))));
        let catInfo = tabs.find(item => {
          return item.list_template == "category_news";
        });
        if (catInfo) {
          this.catInfo = catInfo;
          this.cat_id = catInfo.id;
          this.getContentList();
        }
      }
    },
    getContentList() {
      // 获取对应内容
      let params = {
        req: {
          cat_id: this.cat_id,
          page: this.page,
          limit: this.limit,
          order: "orderby desc"
        }
      };
      getContents(params).then(({ rsp, data }) => {
        if (rsp.code === 0) {
          this.total = data.total;
          this.newsList = data.list;
        }
      });
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      auxiliary(data);
      return res;
    },
    goToDetail(item) {
      let catIdentification = this.catInfo.identification ? this.catInfo.identification : item.cat_id;
      this.$router.push({
        path: `/news/${catIdentification}/${item.id}`
      });
    },

    handleSizeChange(val) {
      this.limit = val;
      this.getContentList(this.actived);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getContentList(this.actived);
    },
    handleTimeToString(v) {
      var chazhi = Cookies.get("Difference");
      var benditime = v*1000-chazhi;
      let date = new Date(benditime);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      M = M > 9 ? M : "0" + M;
      let D = date.getDate();
      D = D > 9 ? D : "0" + D;
      let H = date.getHours();
      H = H > 9 ? H : "0" + H;
      let m = date.getMinutes();
      m = m > 9 ? m : "0" + m;
      let s = date.getSeconds();
      s = s > 9 ? s : "0" + s;
      return `${Y}-${M}-${D} ${H}:${m}:${s}`;
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .tImg {
    width: 100%;
  }
  .b_pic_text {
    position: relative;
    bottom: 9rem;
    margin: 0 auto -4.8rem;
    font-family: YouSheBiaoTiHei,serif;
    font-size: 3.5rem;
    font-weight: 400;
    text-align: center;
    font-style: italic;
    color: white;
    background-color: rgba(0,0,0,.5);
    border-radius: 0.5rem;
  }

  .isFixed {
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100%;
  }

  .process {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    overflow-x: auto;
    height: 3.75rem;
    line-height: 3.75rem;
    background-color: #f2f2f2;

    .step {
      box-sizing: border-box;
      padding: 0 6rem 0 0;
      font-size: 1.1428rem;
      color: #1a1a1a;
      cursor: pointer;

    }

    .isActived {
      border-bottom: 4px solid #635796;
      padding-bottom: 0.75rem;
      // width: 60px;
    }
  }

  .content {
    .dis {
      margin: 0 -0.9375rem;
    }

    .no-data {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }

    .box {
      width: calc(100% / 3);
      display: inline-block;
      padding: 0 20px;
      margin-bottom: 73px;
      cursor: pointer;
      overflow: hidden;

      .oImg {
        width: 100%;
        border-radius: 0.5rem 0.5rem 0 0;
      }
      .fother {
        width: 100%;
        height: 12.5rem;
        position: relative;
        background: #f2f2f2;
        margin-top: -4px;
        border-radius: 0 0 0.5rem 0.5rem;
        .intro {
          background-image: url("/static/service/border_red.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 25rem;
          height: 1.875rem;
          text-align: center;
          line-height: 1.875rem;
          color: #635796;
          font-style: italic;
          position: absolute;
          top: 1.875rem;
          left: 0;
        }

        .btitle {
          padding-top: 5rem;
          padding-left: 3.125rem;
          font-size: 1.1428rem;
          font-weight: 500;
          color: #1a1a1a;
        }

        .bCont {
          color: #969799;
          margin: 1.25rem 3.125rem 0;
        }
      }
    }

    .fother:hover {
      background-color: #635796;
      color: #fff;

      .intro {
        background-image: url("/static/service/border_w.png");
        color: #fff;
      }

      .btitle {
        color: #fff;
      }

      .bCont {
        color: #fff;
      }
    }

    /deep/ .el-pager li {
      background: #fff;
      margin: 0.1rem;
    }
    /deep/ .el-pagination {
      text-align: center;
    }
    /deep/ .el-pagination button:hover,.el-pagination button:focus,.el-pagination button:active {
      color: #635796;
    }
    /deep/ .el-pager li.active {
      background: #635796;
      color: #fff!important;
    }
    /deep/ .el-pager li:hover {
      background: #635796;
      color: #fff!important;
    }
  }
  @media screen and (max-width: 1400px) {
    .process {
      padding: 0 2%;
    }
    .content {
      padding: 3.25rem 2%;
    }
  }
  @media screen and (min-width: 1400px) {
    .process {
      padding: 0 10%;
    }
    .content {
      padding: 3.25rem 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .process {
      padding: 0 15%;
    }
    .content {
      padding: 3.25rem 15%;
    }
  }
}
</style>
